import classNames from 'classnames'
import { createElement, MouseEventHandler } from 'react'

type Props = {
  /**
   * HTML tag.
   */
  as?: string
  children: React.ReactNode
  className?: string
  active?: boolean
  hasArrowIcon?: boolean
  valueKey: string
  onClick?: MouseEventHandler<HTMLSpanElement>
  onChange?: (value: string) => void
}

export const Tab = ({
  as = 'span',
  active,
  valueKey,
  onClick,
  onChange,
  children,
  className,
}: Props) => {
  const handleClick: MouseEventHandler<HTMLSpanElement> = e => {
    onClick && onClick(e)
    onChange && onChange(valueKey)
  }

  return (
    <li
      className={`
        ${
          active &&
          'after:m-0 after:mx-auto after:-mt-0.5 after:block after:w-full after:rounded after:border-b-2 after:text-cool-900'
        }
        ${className}
      `}
    >
      {createElement(
        as,
        {
          className: classNames(
            'flex h-10 cursor-pointer items-center justify-between whitespace-nowrap rounded bg-transparent px-4 text-sm font-medium text-cool-600 transition-colors duration-200 hover:bg-cool-900 hover:bg-opacity-3 hover:text-cool-800 font-body tracking-normal',
            active && 'text-cool-900'
          ),
          onClick: handleClick,
        },
        children
      )}
    </li>
  )
}
